import { memo, type FunctionComponent } from 'react';
// Skillmore UI Components
import ActionSnackbar from '@empathco/ui-components/src/elements/ActionSnackbar';

type DevPlanActionSnackbarsProps = {
  readonly activateFailed?: boolean | null;
  readonly requestFailed?: boolean | null;
  readonly completeCourseFailed?: boolean | null;
  readonly activityFailed?: boolean | null;
  readonly completeAdvisorFailed?: boolean | null;
};

const DevPlanActionSnackbars: FunctionComponent<DevPlanActionSnackbarsProps> = ({
  activateFailed = false,
  requestFailed = false,
  completeCourseFailed = false,
  activityFailed = false,
  completeAdvisorFailed = false
}) => (
  <>
    <ActionSnackbar
        severity="error"
        message="hr.dev_plan.activate_error"
        open={activateFailed}
    />
    <ActionSnackbar
        severity="error"
        message="skill.advisors.request_error"
        open={requestFailed}
    />
    <ActionSnackbar
        severity="error"
        message="hr.dev_plan.course_complete_error"
        open={completeCourseFailed}
    />
    <ActionSnackbar
        severity="error"
        message="skill.development.activity.error"
        open={activityFailed}
    />
    <ActionSnackbar
        severity="error"
        message="skill.advisors.update_error"
        open={completeAdvisorFailed}
    />
  </>
);

export default memo(DevPlanActionSnackbars);
